module.exports = __webpack_public_path__ + "vc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/vc.svg
// module id = 875
// module chunks = 0